import React from 'react';
import { formatCardWhenDisplay } from './ist-datetime';

/** V1-style date + time row — always visible below the card divider. */
export default function TradingCardWhen({ item, prefix = 'Opened', className = '' }) {
  const { prefix: label, stamp } = formatCardWhenDisplay(item, prefix);
  return (
    <div className={`tab-card-when trading-card-when ${className}`.trim()}>
      <time className="tab-share-time" dateTime={item?.openedAt || undefined}>
        {label} {stamp}
      </time>
    </div>
  );
}
